import { gql } from '@apollo/client';
import MessageAttachmentFragment from "./MessageAttachment";
import MessagePartFragment from "./MessagePart";

const SiteChannelMessageFragment = gql`
  fragment SiteChannelMessageFragment on SiteChannelMessage {
    siteChannelId
    author
    authorUserId
    authorUsername
    avatarUrl
    files {
      ...MessageAttachmentFragment
    }
    id
    messageparts {
      ...MessagePartFragment
    }
	  mentions{
		  avatarUrl
		  mentionId
		  name
		  username
	  }
    messageTime
    __typename
  }
  ${MessageAttachmentFragment}
  ${MessagePartFragment}
`;

export default SiteChannelMessageFragment;
